




















































































































































































































import { Component, Vue } from 'vue-property-decorator';
import {
  AbsenceFilter,
  AbsenceUserViewModel,
  AbsenceViewModel,
  AppUserFilter,
  AppUserViewModel,
  StSelectListItemGroup,
  VacationStatsViewModel,
} from '@/services/api/nswag/stapiclient_generated';
import { stAbsenceApi, stAppUserApi, stTeamOverviewApi } from '@/services/st-api';
import AbsenceEdit from '@/views/Absence/AbsenceEdit.vue';
import StTabs from '@/components/tabs/StTabs.vue';
import { TabModel } from '@/components/tabs/tab-model';
import { DateTime } from 'luxon';
import StBadge from '@/components/basic/StBadge.vue';
import CalendarHorizontal from '@/views/Absence/components/CalendarHorizontal.vue';
import AbsenceLegend from '@/views/Absence/AbsenceLegend.vue';
import { notifySuccess } from '@/utlitities/notifications';
import { UserStore } from '@/store/user-module';
import AbsenceTypeIcon from '@/views/Absence/components/AbsenceTypeIcon.vue';
//@ts-ignore
import * as FileSaver from "file-saver";

@Component({
  components: {
    AbsenceTypeIcon,
    AbsenceLegend,
    CalendarHorizontal,
    StBadge,
    StTabs,
    AbsenceEdit,
  },
})
export default class AbsenceTeam extends Vue {
  absenceData: AbsenceUserViewModel[] = [];
  openAbsenceRequests: AbsenceViewModel[] = [];
  year: number = DateTime.local().year;
  activeTabName = 'calendar';
  loading = true;
  delayLoading = false;
  appUser: StSelectListItemGroup[] = [];
  currentUserId: number | undefined = 0;
  vacationStats: VacationStatsViewModel = VacationStatsViewModel.fromJS({});
  absenceList: AbsenceViewModel[] = [];
  currentUser: AppUserViewModel = AppUserViewModel.fromJS({});
  displayOnlyDirectTeamMembers = UserStore.userSettings.hasIndirectManagedTeam;

  get tabs(): TabModel[] {
    return [
      {
        TabName: 'calendar',
        Disabled: false,
      },
      {
        TabName: 'list',
        Disabled: false,
      },
      {
        TabName: 'export',
        Disabled: false,
      },
    ];
  }

  async beforeRouteUpdate(to: any, from: any, next: any) {
    next();
    if (to.name == 'AbsenceTeam') {
      try {
        await this.loadData();
      } finally {
      }
    }
  }

  get displayOnlyDirectTeamMembersSwitch(): boolean {
    return UserStore.userSettings.hasDirectManagedTeam && UserStore.userSettings.hasIndirectManagedTeam;
  }

  async changeYear(plusminus: number) {
    try {
      this.loading = true;
      this.year += plusminus;
      await this.loadData();
    } finally {
      this.loading = false;
    }
  }

  get fromDate(): Date {
    return DateTime.local(this.year, 1, 1, 0, 0, 0, 0).toJSDate();
  }

  async mounted() {
    try {
      this.loading = true;
      await this.loadDataRaw();
    } finally {
      this.loading = false;
    }

    const appUserFilter = AppUserFilter.fromJS({});
    this.appUser = await stAppUserApi.getSelectListForFilter(appUserFilter);
    this.currentUserId = this.appUser![0]!!.items![0]!.id;
  }

  async loadDataRaw() {
    this.absenceData = await stAbsenceApi.getListForAllActiveUsers(this.year, this.displayOnlyDirectTeamMembers);
    this.openAbsenceRequests = await stAbsenceApi.getOpenAbsenceRequests();
  }

  async loadData() {
    try {
      this.delayLoading = true;
      await this.loadDataRaw();
      await this.loadUserAbsencesAndStats();
    } finally {
      this.delayLoading = false;
    }
  }

  async loadAbsenceCalendarData() {
    try {
      this.delayLoading = true;
      await this.loadDataRaw();
    } finally {
      this.delayLoading = false;
    }
  }

  async loadUserAbsencesAndStats() {
    try {
      this.delayLoading = true;
      const absenceFilter = AbsenceFilter.fromJS({});
      absenceFilter.appUserId = this.currentUserId;
      absenceFilter.year = this.year;
      this.absenceList = await stAbsenceApi.getList(absenceFilter);
      this.currentUser = await stAppUserApi.get(this.currentUserId!);

      if (!this.currentUser.isArchived) {
        this.vacationStats = await stAbsenceApi.getVacationStatsForUser(this.year, this.currentUserId!);
      }
    } finally {
      this.delayLoading = false;
    }
  }

  get canEditAbsencesForEmployees() {
    return this.userSettings.CanEditAbsencesForEmployees;
  }

  get canApproveAbsences() {
    return this.userSettings.CanApproveAbsences;
  }

  get userSettings() {
    return UserStore.userSettings;
  }

  get absenceRequests(): any[] {
    return [];
  }

  editAbsence(absence: AbsenceViewModel) {
    if (absence.isReadOnly) {
      return;
    }
    this.$router.push({ name: 'AbsenceTeamEdit', params: { id: absence.id!.toString() } });
  }

  async deleteAbsence(id: number) {
    await stAbsenceApi.delete(id, true);
    await this.loadData();
    notifySuccess('Erfolgreich gelöscht');
  }

  async approveAbsence(absence: AbsenceViewModel) {
    await stAbsenceApi.approve(absence.id!);
    await this.loadData();
    notifySuccess('Abwesenheit genehmigt');
  }

  async rejectAbsence(absence: AbsenceViewModel) {
    await stAbsenceApi.reject(absence.id!);
    await this.loadData();
    notifySuccess('Abwesenheit abgelehnt');
  }

  addAbsence() {
    this.$router.push({ name: 'AbsenceTeamEdit', params: { id: '0' }, query: { day: DateTime.local().toFormat('yyyy-MM-dd') } });
  }

  private exportLoading = false;
  async ExportExcel(year: number) {
    try {
      if (this.exportLoading)
        return;

      this.exportLoading = true;
      let result = await stAbsenceApi.exportExcel(year);
      FileSaver.saveAs(result.data, `SpikeTime_Absences_Export_${year}.xlsx`);
      this.exportLoading = false;
    } finally {
      this.exportLoading = false;
    }
  }
}
